import { Route, Routes } from 'react-router-dom'
import { useDisclosure } from 'summon-ui/mantine'
import { ErrorBoundary } from '@components'
import LootdropOnboarding from '@features/lootdrops/components/LootdropOnboarding'
import useLootdropOnboarding from '@features/lootdrops/hooks/useLootdropOnboarding'
import LootdropCategoryDetailsView from '@features/lootdrops/views/LootdropCategoryDetails.view'
import LootdropDetailsView from '@features/lootdrops/views/LootdropDetails.view'
import LootdropsView from './views/Lootdrops.view'

export const LootdropsViews = () => {
  const { isLootdropOnbardingCompleted } = useLootdropOnboarding({})
  const [opened, { close }] = useDisclosure(!isLootdropOnbardingCompleted)

  return (
    <>
      <Routes>
        <Route path='/' element={<LootdropsView />} errorElement={<ErrorBoundary />} />
        <Route path='/:lootdropSlug' element={<LootdropDetailsView />} errorElement={<ErrorBoundary />} />
        <Route
          path='/:lootdropSlug/:categoryId'
          element={<LootdropCategoryDetailsView />}
          errorElement={<ErrorBoundary />}
        />
      </Routes>
      <LootdropOnboarding open={opened} onClose={close} />
    </>
  )
}
